import React from 'react';

import ContactForm from './contact-form/ContactForm';

import './Contact.css';

const Contact = () => {
    return (
        <div id="contact">
            <div className="container">
                <div className="row">
                    <div className="col-md-5 col-sm-12 ">
                        <div className="contact-title-container">
                            <p className="contact-title">Want to hire <span style={{color:"#ffffff"}}>OneRock</span> for any of your projects?</p>
                            <p className="contact-subtitle">CONTACT US</p>
                        </div>
                    </div>
                    <div className="col-md-7 col-sm-12">
                        <div >
                            <ContactForm />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;


// WEBPACK FOOTER //
// ./src/components/contact/Contact.js